import "babel-polyfill";

import Gl from './gl';

const scene = new Gl();